import * as React from "react";
import "react-table/react-table.css";
import * as TableStyles from "../styles/TableFormats";
import { Header } from "../components/header";
import { orgInfo, orgTypes, DropdownList, userInfo, getDefaultUserInfo } from "../api/dataTypes";
import { getAllOrgsApi, addOrgApi, editOrgApi } from "../api/api-organizations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import ReactTable from "react-table";
import matchSorter from 'match-sorter';
import { AddOrgModal } from "../modals/modal-AddOrg";
import { EditOrgModal } from "../modals/modal-EditOrg";
import { PromiseHelper } from "../classes/promiseHelper";
import { hasAdminRole, hasDistributorRole, getCurrentUser} from "../api/api-account";
// import { isCustomerRole, isOwnerRole } from "src/api/auth-api";


interface State {
  // selected: boolean;
  orgs: orgInfo[];
  addCustModalOpen: boolean;
  editCustModalOpen: boolean;
  // okToAddCustomer: boolean;
}

export interface Props {
}

export class OrganizationsPage extends React.Component<Props, State> {
  private editData: orgInfo = new orgInfo();
  private distOptions: DropdownList[] = [];
  private currentUser:userInfo = getDefaultUserInfo();

  getPromise: PromiseHelper<orgInfo[]> = new PromiseHelper();
  editPromise: PromiseHelper<orgInfo> = new PromiseHelper();
  addPromise: PromiseHelper<orgInfo> = new PromiseHelper();

  constructor(props: Props) {
    super(props);

    this.state = {
      //selected: false,
      orgs: [],
      addCustModalOpen: false,
      editCustModalOpen: false,
    };
  }
  componentDidMount() {
    this.getOrgs();
  }

  componentWillUnmount() {
    this.getPromise.clearPromise();
    this.addPromise.clearPromise();
    this.editPromise.clearPromise();
  }

  render() {
    let isCustomer = !(hasDistributorRole()||hasAdminRole())
    return (
      <React.Fragment>
        <Header />
        <div className="d-flex align-items-center header-page-title nav-divider">
          <div className="m-2 ml-3 mr-auto ">Organizations</div>
          <div className="col-8 d-flex justify-content-end align-items-center">
            <React.Fragment>
            {!isCustomer&&<div>
                <button
                  className="btn btn-outline-secondary m-2 justify-content-right button-standard"
                  onClick={() => {
                    this.setState({ addCustModalOpen: true });
                  }
                  }
                >
                  + Add Org
                </button>
              </div>}
              <AddOrgModal
                isModalOpen={this.state.addCustModalOpen}
                closeModal={() => {
                  this.setState({ addCustModalOpen: false })
                  this.getOrgs();
                }}
                addOrg={this.AddOrg}
                distributorOptions={this.distOptions}
              />

              <EditOrgModal
                isModalOpen={this.state.editCustModalOpen}
                org={this.editData}
                closeModal={() => {
                  this.setState({ editCustModalOpen: false })
                  this.getOrgs();
                }}
                editOrg={this.EditOrg}
                distributorOptions={this.distOptions}
                distIndex={this.state.orgs.findIndex(x => x.orgType === orgTypes.Distributor && x.id === this.editData.distId)}
                disableDropdowns={!(hasAdminRole()||hasDistributorRole())}
              />
            </React.Fragment>
          </div>
        </div>
        <div className="ReactTable component-standard">
          <ReactTable
            data={this.state.orgs}
            filterable={true}
            defaultFilterMethod={(filter, row) => (matchSorter([row[filter.id]], filter.value).length !== 0)}
            showPagination={this.state.orgs.length > 20}
            minRows={10}
            // COLUMNS ////////////////////////////////
            columns={[
              {
                Header: "Name",
                accessor: "name",
                headerStyle: TableStyles.columnHeaderStyle,
                style: TableStyles.dataStyle,
                width: 300
              },
              {
                Header: "Type",
                accessor: "test",
                headerStyle: TableStyles.columnHeaderStyle,
                style: TableStyles.dataStyle,
              },
              {
                Header: "",
                headerStyle: TableStyles.columnHeaderStyle,
                width: 90,
                sortable: false,
                filterable: false,
                show: true,
                Cell: row => (
                  <div>
                    <button
                      className="iconButton"
                      onClick={() => this.handleEdit(row.original)}
                    >
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </button>
                    {/* <button
                      className="iconButton"
                      onClick={() => this.handleDelete(row.original)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button> */}
                  </div>
                )
              }
            ]}
            // COLUMNS END //////////////////
            className="-highlight"
          />
        </div>
      </React.Fragment>
    );
  }

  private getOrgs = () => {
    //if(hasAdminRole()||hasDistributorRole()){
      getCurrentUser().then(res=>{this.currentUser=res!});
      this.getPromise!.newPromise(
        getAllOrgsApi(), result => {
          this.setState({ orgs: result });
          this.distDropdownOptions();
        },
        e => {
          console.log(`Error caught in page-organizations.GetOrgs(). ${e!.message}`);
          alert('Error getting Orgs');
        }
      )
    // }
    // else{
    //   getCurrentUser().then(res=>{
    //     let customerOrg:orgInfo =new orgInfo();
    //     customerOrg.Init({name:res!.customerName!, id:res!.customerId, orgType:orgTypes.Customer, distId:res!.distributorId});
    //     let distOrg:orgInfo = new orgInfo();
    //     distOrg.Init({name:res!.distributorName!, id:res!.distributorId, orgType:orgTypes.Distributor, distId:null});
    //     this.setState({orgs:[customerOrg]});//, distOrg]});
    //     this.distOptions.push({name:distOrg.name,value:distOrg.id!})
    //     //this.distDropdownOptions();
    //   })
    // }
  }

  private handleEdit = (org: orgInfo) => {
    this.editData = org;
    this.setState({ editCustModalOpen: true })
  }

  private distDropdownOptions = () => {
    let distributors: DropdownList[] = this.state.orgs.filter(
      x => x.orgType === orgTypes.Distributor).map(
        c => {
          return { name: c.name, value: this.state.orgs.indexOf(c) };
        })
    distributors.push({ name: "Select....", value: -1 })
    this.distOptions = distributors;
  }

  private AddOrg = (org: orgInfo, distIndex: number) => {
    let newOrg = org;
    if(hasDistributorRole()&&!hasAdminRole()){
      newOrg.distId=this.currentUser.distributorId;
    }
    else if (distIndex >= 0) {
      let distId = this.state.orgs[distIndex].id;
      newOrg.distId = distId;
    }
    this.addPromise!.newPromise(
      addOrgApi(newOrg), result => {
        this.setState({ addCustModalOpen: false })
        this.getOrgs();
      },
      e => {
        console.log(`Error caught in page-organizations.AddOrg(). ${e!.message}`);
        alert('Error adding Org');
      }
    )

  }

  private EditOrg = (org: orgInfo, distIndex: number) => {
    let newOrg = org;
    if(hasDistributorRole()&&!hasAdminRole()){
      newOrg.distId=this.currentUser.distributorId;
      alert(this.currentUser.distributorId)
    }
    else if (distIndex >= 0) {
      let distId = this.state.orgs[distIndex].id;
      newOrg.distId = distId;
    }
    this.editPromise!.newPromise(
      editOrgApi(newOrg), result => {
        this.setState({ editCustModalOpen: false })
        this.getOrgs();
      },
      e => {
        console.log(`Error caught in page-organizations.EditOrg(). ${e!.message}`);
        alert('Error editing Org');
      }
    )

  }
}
